<template>
    <el-select fit-input-width v-model="addressModel" reserve-keyword :placeholder="$t('chooseAddress')"
        @change="findAddress" class="__kfc_orderType_select __kfc_r_7" :class="classes">
        <el-option v-for="address in addresses" :key="address" :label="locale === 'mn' ? address.full_address
            : address.full_address
            " :value="address.full_address">
        </el-option>
    </el-select>
</template>

<script>
import Req from '@/utils/Request';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex'
import { useGtm } from '@gtm-support/vue-gtm';
export default {
    props: ['classes', 'position', 'dragStart'],
    setup (props) {
        const store = useStore()
        const { classes, position, dragStart } = props
        const locale = computed(() => store.getters.locale)
        const gtm = useGtm();

        // const pickupAddress = computed(() => store.getters['address/getPickupAddress']);
        const outlets = ref([]);
        const addressModel = ref(null);
        const selectedAddress = ref(null);
        const addresses = ref([]);
        const getNearestAddresses = async () => {
            const { data: result } = await Req({
                url: '/searchByLocation?lat=' + position.lat + '&lon=' + position.lng,
                type: 3,
                method: 'get',
                hideSuccess: true,
                disableLoader: false
            });
            if (result.success) {
                addresses.value = result.data
                if (dragStart) {
                    addressModel.value = result.data[0].full_address
                    findAddress();
                }

            }
        }
        getNearestAddresses();

        const checkApartment = async (data) => {
            const podkfc = data.podkfc
            const { data: result } = await Req({
                url: '/manager/getOutletNameByPodKfc', body: { podcode: podkfc }, hideSuccess: true,
                disableLoader: false
            })
            if (result.success) {
                gtm.trackEvent({
                    event: 'selected_address',
                    action: 'selected',
                    value: selectedAddress.value?.full_address
                });
                store.dispatch('address/updateDeliveryAddress', selectedAddress.value)
                store.dispatch('address/updateDeliveryOutletName', result.result)
            } else {
                addressModel.value = addressModel.value.full_address
                selectedAddress.value = addressModel.value;
            }
        }


        const findAddress = () => {
            selectedAddress.value = addresses.value.find(x => x.full_address === addressModel.value)
            checkApartment(selectedAddress.value)

        }
        // onMounted(() => {
        //     if (address) {
        //         checkApartment(address)
        //         // addressModel.value = address
        //         // checkOutlets(addressModel.value)
        //     } else {
        //         if (default_outlet.value === pickupAddress.value) {
        //             addressModel.value = ''
        //         } else {
        //             addressModel.value = pickupAddress.value
        //         }
        //     }
        // })
        // getOutlets()
        return {
            addresses, addressModel, locale, outlets, classes, findAddress
        }
    }
}
</script>

<style lang="scss"></style>